import { authors } from './authors';

export const blogPosts = [
  {
    id: 1,
    title: "Building Modern Web Apps with MERN Stack",
    slug: "building-modern-web-apps-with-mern-stack",
    excerpt: "Learn how to create scalable web applications using MongoDB, Express, React, and Node.js",
    content: ` Introduction to MERN Stack DevelopmentThe MERN stack is a powerful combination of technologies that enables developers to build full-stack web applications efficiently.
What is MERN Stack?MongoDB: A NoSQL database for flexible and scalable data storage.
Express.js: A lightweight backend framework for building APIs and handling server-side logic.
React.js: A popular frontend library for building dynamic and interactive user interfaces.
Node.js: A runtime environment that allows JavaScript to run on the server side.
Key FeaturesJavaScript Everywhere: Use JavaScript for both frontend and backend development.
Real-Time Capabilities: Easily implement WebSockets for real-time features.
Great Performance: Leverage asynchronous processing and non-blocking operations.
Extensive Ecosystem: Access a rich collection of libraries and tools to enhance development.
`,
    date: "2024-03-15",
    lastModified: "2024-03-16",
    tags: ["MERN", "Web Development", "JavaScript"],
    categories: ["Development", "Tutorial"],
    readTime: "5 min",
    image: "https://res.cloudinary.com/dqovjmmlx/image/upload/v1735401084/New_Project_dci4lt.jpg",
    author: authors[0],
    views: 1200,
    featured: true,
  },

];
